import React, { useState } from 'react';
import R from 'ramda';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import Paragraph from '@cotyorg/ccx-atoms/Paragraph';
import IconButton from '@cotyorg/ccx-molecules/IconButton';
import LookDescription from '../LookDescription/LookDescription';
import ShopNow from '../ShopNow/ShopNow';

export const ProductDetails = ({
  selectedProduct,
  selectedProductSwatch,
  vto,
  useBuyNowWidget,
  eventHandler,
  handleChannelAdvisor,
  useBuyNowRetailer,
  isMulti = false,
}) => {
  const [isLookDescriptionOpen, setLookDescriptionOpen] = useState(false);
  const isSelectedProductSwatchMulti = !!R.prop(
    'isMulti',
    selectedProductSwatch
  );
  const generateVtoProductDetailsClassNames = () =>
    classNames('vto__product-details', {
      'vto__product-details-look-name': isMulti,
      open: isLookDescriptionOpen,
    });

  return (
    <div className={generateVtoProductDetailsClassNames()}>
      {(isMulti === isSelectedProductSwatchMulti && (
        <Paragraph>{R.prop('itemName', selectedProductSwatch)}</Paragraph>
      )) || <Paragraph />}
      {isMulti && isSelectedProductSwatchMulti && (
        <>
          <IconButton
            size="small"
            iconSrc="/ccx-files/assets/plus.svg"
            extraClass="vto__product-details-look-description-open"
            onClick={() => setLookDescriptionOpen(true)}
          />

          <LookDescription
            shadeList={selectedProductSwatch.shadeList}
            setLookDescriptionOpen={setLookDescriptionOpen}
          />
        </>
      )}

      {!isMulti && (
        <ShopNow
          selectedProduct={selectedProduct}
          selectedProductSwatch={selectedProductSwatch}
          vto={vto}
          useBuyNowWidget={useBuyNowWidget}
          eventHandler={eventHandler}
          handleChannelAdvisor={handleChannelAdvisor}
          useBuyNowRetailer={useBuyNowRetailer}
        />
      )}
    </div>
  );
};

ProductDetails.propTypes = {
  selectedProduct: PropTypes.object,
  selectedProductSwatch: PropTypes.object,
  vto: PropTypes.shape({
    button: PropTypes.shape({
      text: PropTypes.string,
      iconUrl: PropTypes.string,
    }),
    buyNowButton: PropTypes.shape({
      text: PropTypes.string,
    }),
    vtoSourceUrl: PropTypes.string.isRequired,
    actualProductSku: PropTypes.string,
    actualProductSlug: PropTypes.string,
    vtoScriptLoaded: PropTypes.bool,
    products: PropTypes.arrayOf(
      PropTypes.shape({
        slug: PropTypes.string.isRequired,
        title: PropTypes.string.isRequired,
        variants: PropTypes.arrayOf(PropTypes.object),
      })
    ),
  }),
  useBuyNowWidget: PropTypes.bool,
  eventHandler: PropTypes.func,
  handleChannelAdvisor: PropTypes.func,
  isMulti: PropTypes.bool,
  useBuyNowRetailer: PropTypes.bool,
};
